import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Task, TaskMutateMask } from '../protogen/planning/service_pb';
import { TaskService } from '../task.service';

@Component({
  selector: 'app-create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss']
})
export class CreateTaskComponent implements OnInit {
  newTask: Task.AsObject = new Task().toObject();

  constructor(private router: Router,
      private taskService: TaskService) {}

  ngOnInit(): void {}

  async onSave() {
    const mask = new TaskMutateMask().setTitle(true).setTaskState(true);
    const response = await this.taskService.createTask(this.newTask, mask.toObject());
    const newTaskId = response.task?.id;
    this.router.navigateByUrl(`task/${newTaskId}`);
  }
}
